import { object, string } from "yup";

export const broadcastCallValidationSchema = object().shape({
  scheduled_date: string().required("Date is required"),
  slot: string().required("Time slot is required"),
  ivr_message: string().required("Message text is required"),
});

export const broadcastIVRTestSchema = object().shape({
  mobile_number: string().required("Mobile number is required"),
  team_member_name: string().required("Team member name is required"),
  company_name: string().required("Company name is required"),
  entity_name: string().required("Entity name is required"),
});
